import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useStore from "../store/useStore";

import FormHubSpot from "./FormHubSpot";
const apiUrl = process.env.REACT_APP_STRAPI_URL;
export default function GetInTuch({
  title = "Contáctese con nosotros",
  titleClassName = "text-3xl md:text-[40px] lg:text-[45px] leading-[1.3] text-sidom-orange px-2 md:px-0 lg:px-0  font-extrabold mb-[60px] text-left",
}) {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);
  const video = `${apiUrl}/uploads/Dots_Background_10_1_7273030897.mp4`;
  const setVideoUrlError = useStore((state) => state.setVideoUrlError);

  return (
    <>
      <div className="relative border border-sidom-blue    ">
        <video
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          autoPlay
          loop
          muted
          onError={() => {
            setVideoUrlError("No se pudo cargar el video");
          }}
        >
          <source src={video} type="video/mp4" />
        </video>
        <div
          data-aos="fade-up"
          data-aos-delay="900"
          className="  container mt-[70px] md:mt-[100px] lg:mt-[90px]  mb-[70px] md:mb-[100px] lg:mb-[90px]  flex flex-col justify-center items-center text-left "
        >
          {title ? (
            <h1 className={titleClassName}>
              {title}
            </h1>
          ) : null}
          <div className="w-full md:w-[600px] lg:w-[800px] xl:w-[1000px] 2xl:w-[1200px]">
            <FormHubSpot />
          </div>
        </div>
      </div>
    </>
  );
}
